import MarkdownEditor from '../../../../../components/markdownEditor/MarkdownEditor';
import styles from './LlmConfigTab.module.css';

export interface LlmConfigValues {
  systemPrompt: string;
}

interface Props {
  config: LlmConfigValues;
  onChange: (partial: Partial<LlmConfigValues>) => void;
}

export default function LlmConfigTab({ config, onChange }: Props) {
  return (
    <form autoComplete="off" onSubmit={e => e.preventDefault()}>
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>System Prompt</h3>
        <div className={styles.field}>
          <label>Prompt sent to the LLM for every webchat conversation</label>
          <p className={styles.fieldHint}>
            Write in Markdown — use headings, lists, and code blocks to structure instructions.
          </p>
          <MarkdownEditor
            value={config.systemPrompt}
            onChange={systemPrompt => onChange({ systemPrompt })}
            height="420px"
            title="System Prompt"
            filename="system-prompt.md"
            showPreview={false}
          />
        </div>
      </div>
    </form>
  );
}
